import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

/* Positions the arrow; it does not style it. The button itself is an IconButton, which owns its
   own size, fill, border and radius, so nothing here reaches into its appearance.

   Flex rather than block so the wrapper is exactly the button's height and the translate below
   centres honestly, with no line-box descender space underneath. */
export const navigationButton = css`
  position: absolute;
  top: 50%;
  display: flex;
  transform: translateY(-50%);

  /* Every surface these sit on is a swipe track, so on a touchscreen the arrows stand over the
     image duplicating a gesture the customer already has. The modal keeps its thumbnail rail and
     the drawer its dots, so nothing loses a way through the media.

     Asked as a pointer capability rather than a width, so a tablet loses them at any size and a
     narrow desktop window keeps them. any-pointer rather than pointer because pointer describes
     only the primary input, which a touchscreen laptop reports as fine while still swiping
     perfectly well. The same rule as the ProductCarousel controls in
     design-system-candidate-components, and the mirror of its ProductCard dots.

     display: none rather than a visual hide, so the buttons leave the accessibility tree too. */
  @media (any-pointer: coarse) {
    display: none;
  }
`;

export const prevNavigationButton = css`
  left: var(${spacing.md});
`;

export const nextNavigationButton = css`
  right: var(${spacing.md});
`;
